import { useState } from "react";
import { Loader2 } from "lucide-react";
import { api, formatApiError, TOKEN_KEY } from "@/lib/api";

export const StaffLogin = ({ onLogin }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem(TOKEN_KEY, data.token);
      onLogin();
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="ad-login-wrap">
      <img className="ad-login-logo" src="/brand/logo-black.png" alt="Wax Moi" width="835" height="240" />
      <form className="form staff-login" onSubmit={submit} data-testid="staff-login-form">
        <p className="eyebrow">Wax Moi admin</p>
        <h2>Welcome back</h2>
        <div className="field"><label htmlFor="email">Email</label>
          <input id="email" type="email" required autoComplete="username" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="login-email-input" /></div>
        <div className="field"><label htmlFor="password">Password</label>
          <input id="password" type="password" required autoComplete="current-password" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="login-password-input" /></div>
        {error && <p className="form-error" data-testid="login-error">{error}</p>}
        <button className="btn gold" type="submit" disabled={busy} data-testid="login-submit-button">
          {busy ? <Loader2 size={16} className="spin" /> : "Log in"}
        </button>
      </form>
    </div>
  );
};
